import { StateCreator } from 'zustand';
import { jwtDecode } from 'jwt-decode';
import { AuthStore, AuthAux } from '../types';

const isTokenExpired = (token: string) => {
  try {
    const decoded: any = jwtDecode(token);
    if (!decoded?.exp) return true;
    return Date.now() >= decoded.exp * 1000;
  } catch {
    return true;
  }
};

export const createAuxSlice: StateCreator<AuthStore, [], [], AuthAux> = (
  _set,
  get
) => ({
  isAuth: () => {
    const current = get().data;
    const token = current?.tokenData?.accessToken;

    if (!token) {
      return false;
    }

    if (isTokenExpired(token)) {
      get().logout?.();
      return false;
    }

    return true;
  },
});
